// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","539":"bujin","996":"info"}[chunkId] || chunkId) + "." + {"177":"4a34eada","228":"7abde247","539":"5389d809","996":"15e0bdd8"}[chunkId] + ".js";
};